module.exports = __webpack_public_path__ + "img/28-6.479d037c.jpg";